import React, { FC, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  Sorting,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { MONEY_FORMAT } from 'constants/formats';
import { useAuth } from 'context/auth';
import $createStore from 'utils/create-store-instance';
import { onExporting } from 'utils/exportingExcel';

import { CreateEditModal, DeleteModal } from './components';

//import { CreateEditModal, DeleteModal } from './components';

export const Pricing: FC = () => {
  const { id } = useParams<{ id: string }>();
  const refGrid = useRef<DataGrid | null>(null);
  const { getClaims }: any = useAuth();

  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);

  const dataSource: any = useMemo(() => {
    return $createStore(`/v1/ContractorNomenclaturePrice?contractorId=${id}`, 'id');
  }, [id]);

  const refresh = () => {
    refGrid.current?.instance.refresh();
  };

  const paymentMethodsDataSource = useMemo(() => {
    return $createStore('/v1/ContractorNomenclaturePrice/types', 'id');
  }, []);

  const canLookPrice = getClaims(['CanLookContractorNomenclaturePrice']);

  return (
    <>
      <div className="pr-2 pt-1">
        <AppLayoutTop title="">
          <ClaimsProvider claimsBlock={['CanCreateContractorNomenclaturePrice']}>
            <Button
              width={120}
              text="Добавить"
              type="default"
              onClick={() => {
                setDetailId(null);
                setModalIsVisible(true);
              }}
            />
          </ClaimsProvider>
        </AppLayoutTop>
      </div>

      {modalIsVisible && (
        <CreateEditModal
          changeVisible={setModalIsVisible}
          id={detailId}
          refresh={refresh}
          visible={modalIsVisible}
          contractorId={Number(id)}
        />
      )}

      {modalIsVisibleDelete && (
        <DeleteModal
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          id={detailId}
        />
      )}

      <AppCard>
        <DataGrid
          dataSource={dataSource}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={false}
          onExporting={onExporting}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <Sorting mode="multiple" />
          <StateStoring enabled={true} type="localStorage" storageKey="ContractorNomenclaturePriceStoreKey" />
          <Export enabled={true} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <Column dataField="paymentMethod" caption="Способ оплаты" groupIndex={0}>
            <Lookup dataSource={paymentMethodsDataSource} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="factoryName" caption="Площадка" />
          <Column dataField="nomenclature" caption="Рецепт" sortOrder="desc" />
          <Column dataField="density" caption="Подвижность" />
          <Column dataField="dateBegin" caption="Дата начала" dataType="date" />
          <Column dataField="dateEnd" caption="Дата окончания" dataType="date" />
          <Column dataField="objectName" caption="Объект" />
          <Column dataField="price" caption="Цена за куб" format={MONEY_FORMAT} visible={canLookPrice} />

          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            allowSorting={false}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditContractorNomenclaturePrice']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisible(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteContractorNomenclaturePrice']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </>
  );
};
